const topics = [
  { label: '#顶流塌房', heat: '1286万', color: 'primary' },
  { label: '#选秀黑幕', heat: '943万', color: 'primary' },
  { label: '#明星出轨', heat: '2156万', color: 'accent' },
  { label: '#合约纠纷', heat: '567万', color: 'secondary' },
  { label: '#饭圈互撕', heat: '1834万', color: 'accent' },
  { label: '#综艺翻车', heat: '421万', color: 'secondary' },
  { label: '#私生活曝光', heat: '789万', color: 'primary' },
  { label: '#资本操控', heat: '654万', color: 'secondary' },
  { label: '#片场耍大牌', heat: '876万', color: 'accent' },
  { label: '#颁奖黑幕', heat: '345万', color: 'secondary' },
];

export default function Topics() {
  const getColorClasses = (color: string) => {
    switch (color) {
      case 'primary':
        return 'bg-primary-50 text-primary-700 border-primary-200 hover:bg-primary-100 hover:border-primary-300';
      case 'accent':
        return 'bg-accent-50 text-accent-700 border-accent-200 hover:bg-accent-100 hover:border-accent-300';
      default:
        return 'bg-secondary-50 text-secondary-700 border-secondary-200 hover:bg-secondary-100 hover:border-secondary-300';
    }
  };

  return (
    <section id="topics" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-5xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            热门话题
          </h2>
          <p className="text-foreground-500 text-sm">当前最热讨论标签 · 点击探索更多</p>
        </div>

        <div className="flex flex-wrap justify-center gap-3">
          {topics.map((item, i) => (
            <a
              key={i}
              href="#carousel"
              className={`inline-flex items-center gap-2 px-4 py-2.5 border rounded-full transition-all duration-200 cursor-pointer ${getColorClasses(item.color)}`}
            >
              <span className="text-sm font-medium whitespace-nowrap">{item.label}</span>
              <span className="text-xs opacity-70 whitespace-nowrap">{item.heat}</span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}